import { render, staticRenderFns } from "./T-F-Under-Grad-2024.vue?vue&type=template&id=2f43a61b&scoped=true&"
import script from "./T-F-Under-Grad-2024.vue?vue&type=script&lang=js&"
export * from "./T-F-Under-Grad-2024.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f43a61b",
  null
  
)

export default component.exports